import { Buffer } from 'buffer';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { IdpAttributeMappingsConfig, MetadataChoice, SSOConfig } from 'src/actions/integrations/sso/ssoConfigResource';

export function useOnSave({ resetErrors, update, validate, workingState }) {
  const dispatch = useDispatch();
  const saveHandler = useCallback(() => {
    dispatch(resetErrors());
    if (!dispatch(validate(workingState))) {
      return;
    }

    const attrsToUpdate: Partial<SSOConfig> = {
      enabled: workingState.enabled,
      forceAuthentication: workingState.forceAuthentication,
      jitUserCreation: workingState.jitUserCreation,
    };

    if (workingState.jitUserCreation) {
      attrsToUpdate.idpAttributeMappingsConfig = buildIdpAttributeMappingsConfig(
        workingState.idpAttributeMappingsConfig
      );
    }

    if (workingState.metadataOption === MetadataChoice.URL) {
      attrsToUpdate['identityProviderMetadataURL'] = workingState.metadataURL.trim();
      attrsToUpdate['identityProviderMetadata'] = '';
    } else {
      attrsToUpdate['identityProviderMetadataURL'] = '';
      attrsToUpdate['identityProviderMetadata'] = Buffer.from(workingState.metadata.trim()).toString('base64');
    }

    dispatch(update({}, attrsToUpdate));
  }, [dispatch, resetErrors, update, validate, workingState]);

  return { saveHandler };
}

function buildIdpAttributeMappingsConfig(
  idpConfig?: IdpAttributeMappingsConfig
): IdpAttributeMappingsConfig | undefined {
  if (!idpConfig) {
    return;
  }

  return {
    ...idpConfig,

    roleMappings: idpConfig.roleMappings || [],
    inboxMappings: idpConfig.inboxMappings || [],
    defaultRoles: idpConfig.defaultRoles || [],
    defaultInboxes: idpConfig.defaultInboxes || [],
  };
}
